<template>
  <div v-if="conversation.type === ConversationType.General" class="avatar-area">
    <FriedH4 class="participants-number">{{ participants.length + 1 }}</FriedH4>
  </div>
  <span
    v-else-if="filteredParticipants.length <= 2"
    :class="[
      'chat-list-item-avatar-container',
      { 'multiple-avatars': filteredParticipants.length >= 2 },
    ]"
  >
    <FriedAvatar
      v-for="participant in filteredParticipants"
      :key="getParticipantsDetails(participant).id"
      class="chat-list-item-avatar"
      :name="
        getParticipantsDetails(participant).fullName || getParticipantsDetails(participant).email
      "
      :thumb-url="getParticipantsDetails(participant).thumbUrl"
    />
  </span>
  <div v-else class="avatar-area">
    <FriedH4 class="participants-number">{{ conversation.participants.length }}</FriedH4>
  </div>
</template>
<script lang="ts">
import type { PropType } from 'vue';
import { computed, defineComponent } from 'vue';
import type { ChatParticipant, Conversation } from '../types';
import { ConversationType } from '../types';
import { ChatHelper } from '../helpers';

export default defineComponent({
  props: {
    conversation: {
      type: Object as PropType<Conversation>,
      default: () => ({}),
    },
    participants: {
      type: Array as PropType<ChatParticipant[]>,
      default: () => [],
    },
  },
  setup(props) {
    const filteredParticipants = computed(() =>
      ChatHelper.getConversationParticipants(props.participants, props.conversation.participants)
    );

    return {
      filteredParticipants,
      ConversationType,
      getParticipantsDetails: ChatHelper.getParticipantsDetails,
    };
  },
});
</script>
<style lang="scss" scoped>
@import '@getaccept/dsr-shared-new/src/scss/chat-list-item';
</style>
